import React from "react";
import { useModalContext } from "../../contexts/ModalContext/context";
import { Button } from "../../UI/Button";

export interface IProps {
  label: string;
  isDisabled?: boolean
}

export const OpenModalButton: React.FC<IProps> = (props) => {
  const { setIsOpen } = useModalContext();

  const openModal = () => setIsOpen(true);

  return (
    <>
      <Button onClick={openModal} isDisabled={props.isDisabled}>{props.label}</Button>
      {props.children}
    </>
  );
};
